import React, { useEffect } from "react";
import {
  CssBaseline,
  Box,
  CircularProgress,
} from "@mui/material";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";

import i18n from "./i18n/i18n";
import IzedLandingPage from "./containers/IzedLandingPage";

const App = () => {
  const language = useSelector((state) => state.language.language);

  useEffect(() => {
    i18n.changeLanguage(language);
    document.body.setAttribute("dir", language === "ar" ? "rtl" : "ltr");
  }, [language]);

  const cacheRtl = createCache({
    key: language === "ar" ? "muirtl" : "mui",
    stylisPlugins: language === "ar" ? [prefixer, rtlPlugin] : [],
  });

  return (
    <CacheProvider value={cacheRtl}>
      <CssBaseline />
      <Router>
        <React.Suspense
          fallback={
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
              }}
            >
              <CircularProgress />
            </Box>
          }
        >
          <Routes>
            <Route path="/" element={<IzedLandingPage />} />
            <Route path="*" element={<IzedLandingPage />} />
          </Routes>
        </React.Suspense>
      </Router>
    </CacheProvider>
  );
};

export default App;
